<template>
    <div> 
		<div  v-if="tradingAccountList.totalLiveAccounts > 0" >
			<div v-if="(parseInt(get_user.profile.gAuthenticatorEnabled) == 0 && authComponent && transaction_id != '' && !congModuleBonus)">
                <app-twofa  :call_from="request_page"></app-twofa>
            </div>
			<div v-else>
				<div class="mainTitle text-center mt-4 mb-3">
					<h3>{{$t('removeBonus')}}</h3>
					<complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
					<message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
				</div>
				
				<div class="CustomBlockWidth inMiddle-area whitebox p-4" > 
                    <div class="justify-content-center">  
                        <!----------------bonus request otp-------------------------->   
                        <div class="partcipate-fund" v-if="transaction_id == '' && !congModuleBonus">
                            <div class=" w-100">
								<div class="form-group field-wrapper">
									<account-id></account-id>
								</div>
							</div>
							<div class="form-group field-wrapper dob" v-if="bonus !== '' && parseFloat(bonus) == 0">
								<ul><li>{{ $t('removebonusMsz1') }}</li></ul>
							</div>
							<div  v-if="bonus !== '' && parseFloat(bonus) > 0">
								<div class="form-group field-wrapper dob">
									<input placeholder=" " type="text" v-model="bonus"  v-validate="{ required: true }" name="bonus" class="float-field form-control"  :class="{ 'is-invalid': submitted && errors.has('bonus') }" ref="bonusInput" readonly />
									<label for="password" class="float-label">{{$t('allowBonus')}}</label>
								</div>
							</div>
							<div class="col-12 p-0" v-if="bonus !== '' && parseFloat(bonus) > 0">
								<div class="submitButton w-100 mt-2 text-center">
									<button class="prism_btn w-150" @click="submitRequestOtp()">{{$t('submit')}}</button>
								</div>
							</div>
                        </div>
                        <!------------------------------------------------------------>
                        <div class="partcipate-fund" v-if="transaction_id != '' && !congModuleBonus">
                            <div v-if="(parseInt(get_user.profile.gAuthenticatorEnabled) == 1)">
                                <p class="mb-3 text-center">{{ $t('googleAuth1') }} <strong>{{ $t('googleAuth2') }}</strong> {{ $t('googleAuth3') }}. </p>
                                <div class="form-group field-wrapper">
                                    <input type="text" placeholder="000 000" class="mdb-select md-form form-control" v-model="otp" v-validate="{ required: true, max: 6,numeric : true }" name="otp"  :class="{ 'is-invalid': submittedCheckOtp && errors.has('otp') }" ref="otpInput">
                                    <ul><li v-for="error in errors.collect('amount')">{{ otp }}</li></ul>
                                </div> 
                                <div class="form-group text-center field-wrapper">
                                    <button class="prism_btn btn_sm " v-on:click="submitCheckOtp()">{{ $t('validate') }} </button>
                                </div>
                                <div class="clearfix"></div>
                                <div class="d-flex align-items-center justify-content-between border-top pt-3 mt-3"> 
                                    <div class="desc text-center">
                                        <p>{{ $t('googleAuth4') }} <a v-on:click="resendLink()" href="#"><strong>{{ $t('googleAuth5') }}</strong></a></p>
                                    </div>
                                </div>
                                <div class="clearfix"></div>
                            </div>
                            
                            <div class="middleBox1"  v-if="(parseInt(get_user.profile.gAuthenticatorEnabled) == 0 && !authComponent)">
                                <div class="congratulations">
                                    <div class="logo_congrats">
                                        <img src="../../../../static/fxView/images/bnous.svg" alt="Icon">
                                    </div>
                                    <div class="subtitle">
                                        <p class="mb-3">{{ $t('dear') }} <strong class="green">{{get_user.username}}</strong>
                                            {{ $t('googleAuth6') }} <strong>{{get_user.email}} . </strong> {{ $t('bonusGoogleAuth') }}
                                        </p>
                                        <a v-on:click="resendLink()" href="#" class="mb-3"><strong>{{ $t('googleAuth7') }}</strong></a>
                                    </div>
                                </div>
                                <div class="clearfix"></div>
                                <div class="d-flex align-items-center justify-content-between enble2fa border-top pt-3 mt-3">
                                    <div class="ico mr-3">
                                        <img src="../../../../static/fxView/images/google_auth.png" alt="2fa">
                                    </div>
                                    <div class="desc w-75">
                                        <h5 class="mb-2"><strong>{{ $t('googleAuth8') }}</strong></h5>
                                        <p>{{ $t('googleAuth9') }} <a v-on:click="authComponent = true" href="#"><strong>{{ $t('Bonus18') }}</strong></a></p>
                                    </div>
                                </div>
                            </div> 
                        </div> 

                        <!------------congo msz final for bonus page------------------------->
                        <div class="col-12" v-if="congModuleBonus">
							<div class="middleBox1">
								<div class="stepForm">
									<div class="row">
										<div class="col-12">
											<div class="congratulations">
												<div class="logo_congrats">
													<img src="../../../../static/fxView/images/congrats.png" alt="Icon">
												</div>
												<div class="subtitle">
													<h3>{{$t('congo')}} <span class="green">{{get_user.username}}</span></h3>
													<p>{{$t('removeBonusCongoMsz')}} : <span class="green">{{account_id}}</span></p>
													<ul class="includeWdth">
														<li><strong>{{$t('removeBonus')}}</strong>{{bonus}}</li>
													</ul>
												</div>
											</div>
										</div> 
										<div class="col-12">
											<div class="signupbtn full-width submitButton w-100 mt-4 text-center">
												<router-link :to="'/dashboard'" class="prism_btn">{{$t('goToDash')}}</router-link>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>  
                        <!-------------------------------------------------------------------->
                    </div> 
                </div>
			</div>
		</div>
		<div v-else>
            <div class="mainTitle  text-center my-3">
                <h3>{{ $t('noTradingAccFound') }}</h3>
            </div>
            <no-trading-account></no-trading-account>
        </div>
    </div>
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    export default {
        name: 'Remove-Bonus',
        mixins: [fxViewMixins],
        data() {
            return {
				pageName : this.$options.name,
				//============message and loader ===========
                response_msg : '',
                msg_type : '',
                pageLoader : false,
				//==========================================
				//-----select account----
				selectAccount : false,
                account_id : '',
				act_account_id : '',
				demo_live : '',
				platform :'',
				//-----------------------
                bonus : '',
                submitted : false,
                congModuleBonus : false,
                balance_bonus : '',
				
				otp : '',
                transaction_id : '',
                submittedCheckOtp : false,
				
				authComponent : false,
                request_page : 'bonus-remove'
            }
        },
        methods:{
			resendLink(){
                let input_json = {
                    'globalParams' : {
                        'trans_id' : this.transaction_id.toString()
                    } ,'localParams' : {'parameter' : this}
                }
                this._runResendEmailLinkBonus(input_json)
            },
			submitRequestOtp(){
                const _that = this
                _that.submitted = true; 
                _that.$validator.validate().then(valid => {
                    if (valid) {
                        let input_json={
                            'globalParams' :{
                                'account_id' : _that.account_id ,
								'act_account_id' : _that.act_account_id,
								 'amount' : '100',
                                "operation" : "REMOVE_BONUS"
                            },
                            'localParams' :{ "parameter" : _that }
                        }
                        _that._runBonusRequestOtp(input_json)
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                });
            },
			submitCheckOtp(){
                const _that = this
                _that.submittedCheckOtp = true;
                _that.$validator.validate().then(valid => {
                    if (valid) {
                        let input_json={
                            'globalParams' :{
                                'google_token' : _that.otp.toString() ,
                                'trans_id' : _that.transaction_id.toString()
                            },
                            'localParams' :{ "parameter" : _that }
                        }
                        _that._runRemoveBonus(input_json)
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                });
            },
            tradingBonus(){
				let input_json = {
                    'globalParams' : {
                        'account_id' : this.account_id,   //5111714,
						'act_account_id' : this.act_account_id,						
                        'demo_live' : this.demo_live , 
                        'platform' : this.platform
                    } ,'localParams' : {'parameter' : this, 'module' : 'remove-bonus'}
                }
                this._runGetAccountDetails(input_json)
            },
            
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/bonus/remove_bonus.vue